import {
  defaultHistoryFields,
  isDeletedField
} from "@/components/Tables/defaultFields";
import StringFilterModel from "@/components/Tables/Filters/models/stringFilterModel";

let unionsFields = [
  {
    key: "name",
    label: "Профсоюз",
    filter: new StringFilterModel()
  },
  {
    key: "professionalGroups",
    label: "Профгруппы"
  }
];

const unionsHistoryFields = [...unionsFields, ...defaultHistoryFields];

unionsFields.push(isDeletedField);

export { unionsFields, unionsHistoryFields };
